import { render, staticRenderFns } from "./social-aspect.vue?vue&type=template&id=2b029e20&scoped=true&"
import script from "./social-aspect.vue?vue&type=script&lang=js&"
export * from "./social-aspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b029e20",
  null
  
)

export default component.exports